.main_row {
	margin-right: 20px !important;
	margin-left: 20px !important;
	margin-top: 5px;
	padding-bottom: 1em;

	@media (max-width: 750px) {
		margin-right: 10px !important;
		margin-left: 10px !important;
	}

	.main_col {
		display: flex;
		flex-direction: column;

		width: 100%;
		box-shadow: 5px 5px 10px #dfe1e6;
		background-color: white;

		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;

		@media (max-width: 750px) {
		}

		.main_form {
			.div_image {
				display: flex;
				justify-content: center;
				align-items: center;

				.icon {
					cursor: pointer;
					max-width: 50%;
					border-radius: 5px;
					margin-top: 10px;
					margin-bottom: 10px;

					@media (max-width: 750px) {
						max-width: 7em;
						margin-top: 5px;
					}
				}
			}

			.div_name {
				padding-top: 10px;
				padding-left: 10px;

				.div_detail {
					.user_name {
						margin-bottom: 0px;
					}

					.company_name {
						font-size: 14px;
						color: #7fb02f;
					}
				}

				.div_list {
					margin-top: 10px;

					.col_list {
						border-style: dashed !important;
						border: 1px solid #e4e6ef;
						border-radius: 5px;
						padding: 5px;

						.list_title {
							font-size: 14px;
							font-weight: 600;
						}

						.list_item {
							font-size: 13px;
						}
					}
				}
			}
		}

		.tab_form {
			// height: 70%;
			overflow-y: auto;

			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}

			&::-webkit-scrollbar-track {
				background: #f1f1f1;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}

			.tab_content {
				.content_main_row {
					margin-top: 10px;

					.label {
						@media (max-width: 400px) {
							font-size: 13px;
						}
					}
				}
			}
		}

		.footer_form {
			// height: 10%;
			display: flex;
			justify-content: right;
			padding-right: 10px;
			padding-top: 5px;
			padding-bottom: 5px;
		}
	}
}
